import { SET_TITLE } from '../actions/types';

export default function title(state = null, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_TITLE:
				return action.payload;

			// no default
		}
	}

	return state;
}
